import { useState } from "react";
import { Trash2, Save } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Input } from "../ui/input";

const ThemeRow = ({ theme, call, reload }) => {
  const [name, setName] = useState(theme.name);
  const [color, setColor] = useState(theme.color);
  const save = async () => { try { await call("put", `/admin/themes/${theme.id}`, { name, color }); } catch { return; } toast.success("Thème enregistré"); reload(); };
  const remove = async () => {
    if (!window.confirm(`Supprimer le thème « ${theme.name} » ?`)) return;
    try { await call("delete", `/admin/themes/${theme.id}`); } catch { return; }
    toast.success("Thème supprimé"); reload();
  };
  return (
    <li className="flex items-center gap-2 rounded-[20px] bg-white p-3 shadow-sm" data-testid={`admin-theme-${theme.slug}`}>
      <input type="color" value={color} onChange={(e) => setColor(e.target.value)} className="h-10 w-12 cursor-pointer rounded-lg border-0 bg-transparent" aria-label="Couleur" data-testid={`admin-theme-color-${theme.slug}`} />
      <Input value={name} onChange={(e) => setName(e.target.value)} className="flex-1" data-testid={`admin-theme-name-${theme.slug}`} />
      <Button variant="ghost" size="icon" aria-label="Enregistrer" onClick={save} data-testid={`admin-theme-save-${theme.slug}`}><Save className="w-5 h-5" /></Button>
      <Button variant="ghost" size="icon" aria-label="Supprimer" onClick={remove} data-testid={`admin-theme-delete-${theme.slug}`}><Trash2 className="w-5 h-5 text-[#F0303A]" /></Button>
    </li>
  );
};

export const ThemesTab = ({ themes, call, reload }) => {
  const [name, setName] = useState("");
  const [color, setColor] = useState("#FF8A1F");
  const add = async (e) => {
    e.preventDefault();
    try { await call("post", "/admin/themes", { name, color }); } catch { return; }
    toast.success("Thème ajouté"); setName(""); reload();
  };
  return (
    <div>
      <form onSubmit={add} className="flex items-center gap-2">
        <input type="color" value={color} onChange={(e) => setColor(e.target.value)} className="h-10 w-12 cursor-pointer rounded-lg border-0 bg-transparent" aria-label="Couleur" data-testid="admin-new-theme-color" />
        <Input required placeholder="Nouveau thème" value={name} onChange={(e) => setName(e.target.value)} data-testid="admin-new-theme-name" />
        <Button type="submit" className="rounded-full bg-[#4CC417] hover:bg-[#3fae10]" data-testid="admin-add-theme-btn">Ajouter</Button>
      </form>
      <ul className="mt-5 space-y-3">{themes.map((t) => <ThemeRow key={`${t.id}-${t.name}-${t.color}`} theme={t} call={call} reload={reload} />)}</ul>
    </div>
  );
};
